import ChannelForm from './ChannelForm';

export default ChannelForm;
